module.exports = __webpack_public_path__ + "static/media/cwblabs-logo.9f5cd27a.svg";